import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

interface VacationPeriodSellFieldProps {
    index: number;
}

const VacationPeriodSellField: React.FC<VacationPeriodSellFieldProps> = ({ index }) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={`vacationPeriods.${index}.hasSellDays`}
            control={control}
            render={({ field }) => (
                <label htmlFor={`vacation-sell-${index}`} className="flex h-10 items-center gap-2 text-sm font-medium text-gray-700">
                    <input
                        id={`vacation-sell-${index}`}
                        type="checkbox"
                        checked={Boolean(field.value)}
                        onChange={(e) => field.onChange(e.target.checked)}
                        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    />
                    Abono pecuniário
                </label>
            )}
        />
    );
};

export default VacationPeriodSellField;
